<template>
  <div id="letter">letter</div>
</template>

<script>
export default {
  name: "index",
};
</script>

<style scoped></style>
